import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { ItemDataSuggestionApiClient } from 'api/itemDataSuggestion';
import { ProcessStatus } from 'models/types';
import { PaginationModel, ItemDataSuggestionModel } from 'models';

export function useDetailedStatusItemDataSuggestions(status: ProcessStatus) {
  return useQuery<PaginationModel<ItemDataSuggestionModel>>({
    queryKey: ['item-data-suggestions-detailed-status', status],
    queryFn: () => ItemDataSuggestionApiClient.getDetailedStatusSuggestions(status),
    enabled: !!status
  });
}

export function useApproveItemDataSuggestion() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (payload: { item_data_suggestion_id: string }) =>
      ItemDataSuggestionApiClient.approveSuggestion(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['item-data-suggestions-detailed-status'] });
      toast({
        title: 'Item data suggestion approved successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'Failed to approve item data suggestion',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });
}

export function useRejectItemDataSuggestion() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (payload: { item_data_suggestion_id: string }) =>
      ItemDataSuggestionApiClient.rejectSuggestion(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['item-data-suggestions-detailed-status'] });
      toast({
        title: 'Item data suggestion rejected successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'Failed to reject item data suggestion',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });
}
